var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SecurityTab.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-233b1591!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SecurityTab.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/profile/profileTabs/SecurityTab.vue
// module id = 393
// module chunks = 61